
import React from 'react';
import { getRGB } from "../../../lib/color";
import { ImgTint } from "../../components/img-tint";
import { createUser } from "../../onboarding/actions";
import { CookieWrap as Cookies } from "../../helper/cookie-wrap";
import {ONBOARDING_TOKEN_LABEL, TOKEN_LABEL, REFRESH_TOKEN_LABEL} from "../../../lib/token";
import { Redirect } from "react-router-dom";
import { css_file_to_url } from "../../helper/css-util";
import LoginBox from "../login-box";
import {DISPLAY_NEW_ACCOUNT, DISPLAY_NEW_ACCOUNT_PASSWORD} from "../login-box/login-box";
import {urlParamToObj} from "../../../lib/url-util";
import {OptionMenu} from "../../../lib/prm/option-menu";
import {Name} from "../../../lib/prm/name";
import {FlowRender} from "../../../lib/flow-render";
import {is_production_mode} from "../../helper/execute-mode";
import {NewAccountPrimer} from "../cd-explorer-primer";

const kyc_switch = new OptionMenu(
  new Name("kyc_switch"),
  [
    new Name("no_kyc", "No KYC"),
    new Name("dev_kyc", "Dev KYC"),
    new Name("prod_kyc", "Prod KYC"),
  ]);

const ALL_PRMS = new FlowRender(0, [
  kyc_switch,
]);

class NewAccount extends React.Component {

  constructor(props) {
    super(props);
    const new_state = {
      first_name: "",
      last_name: "",
      email: "",
      error: false,
      error_message: "",
      loading: false,
      show_prm: false,
      show_primer: false,
      primer_shown: false,
      welcome_video: true,
    };
    const app_state = {};
    if (is_production_mode(props.config)) {
      app_state.kyc_switch = "prod_kyc";
    }
    ALL_PRMS.init(new_state, app_state, this);
    this.state = new_state;
  }

  componentDidMount = () => {
    this.props.clearOnboardingData();
    document.addEventListener("keydown", this.onKeyPressed);
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyPressed);
  }

  onKeyPressed = event => {
    if (event.code === "KeyH" && event.ctrlKey) {
      event.preventDefault();

      this.setState({
        show_prm: !this.state.show_prm,
      })
    }
  }

  doKYC = () => {
    const k_sw = kyc_switch.getValue(this.state).id;
    const has_app = this.props.app.wlf.apps && this.props.app.wlf.apps.hyperverge;
    return has_app && k_sw !== "no_kyc";
  }

  showPrimer = (first_name, last_name, email, phone_number) => {
    if (this.state.primer_shown) {
      // Don't show the primer twice
      this.createNewAccount2(first_name, last_name, email, phone_number);
      return;
    }

    this.setState({
      first_name,
      last_name,
      email,
      phone_number,
      show_primer: true,
    })
  }

  hidePrimer = () => {
    this.setState({
      show_primer: false,
      primer_shown: true,
    })
    this.createNewAccount2(
      this.state.first_name,
      this.state.last_name,
      this.state.email,
      this.state.phone_number);
  }

  createNewAccount2 = (first_name, last_name, email, phone_number, password) => {
    this.setState({
      error: false,
      error_message: null,
      loading: true,
      redirect_url: "",
    });
    const args = urlParamToObj(this.props.location.search);
    if (args.purchase_item) {
      // Purchase item deets, decode from base64
      args.purchase_item =
        JSON.parse(Buffer.from(args.purchase_item, 'base64'));
    }
    args.kyc_switch = kyc_switch.getValue(this.state).id;
    args.password = password;

    createUser(
      this.props.wlf_id,
      email,
      first_name,
      last_name,
      phone_number,
      this.doKYC(),
      args)
      .then(result => {

        if (result.account_exists) {
          const args = {
            username: email,
            acct_exists: result.confirmed ? "confirmed" : "not_confirmed",
            create_acct_on_login: "1",
          }
          this.setState({
            error: false,
            error_message: "",
            loading: false,
          })
          return this.props.navigatePath("/login", args);
        }

        this.setState({
          error: !result.success,
          error_message: result.success ? "" : result.message,
          loading: false,
          redirect_url: result.redirect_url,
        });
        if (result.success) {
          this.props.dataToStore(result.onboarding, 0);
          this.props.dwollaUpdate(result.dwolla, 0);
          this.props.tdaUpdate(result.tda, 0);

          // User login
          this.props.onboardingLogin(
            result.name, result.user_id, result.account_type, result.token, result.id_token);

          // Set the cookie
          const cookies = new Cookies();
          if (result.token) {
            cookies.set(ONBOARDING_TOKEN_LABEL, result.token, { path: '/' });
          }
          if (result.id_token) {
            cookies.set(TOKEN_LABEL, result.id_token, { path: '/'});
          }
          if (result.refresh_token) {
            cookies.set(REFRESH_TOKEN_LABEL, result.refresh_token, { path: '/'});
          }
        }
      }
    )
  };

  renderRightPanel = () => {

    const client = this.props.client;
    const blockStyle = {
        display: "inline-block",
        zIndex: "10",
        verticalAlign: "top",
        marginTop: "8rem",
        marginLeft: "8rem",
    };

    const bold = !!client.top_panel_text.bold;
    const topPanelStyle = {
        fontFamily: client.top_panel_text.font,
        fontSize: client.top_panel_text.size + "px",
        color: getRGB(client.color.sign_on_panel_text),
        fontWeight: bold ? "bold" : "normal",
    };
    const text_style = {
      color: "black",
      visibility: this.state.show_prm ? "visible" : "hidden",
    }
    return (
      <div className="block-style-responsive view-ac-right-main-block" style={blockStyle}>
        <h1 className="top-panel-style-responsive title view-ac-right-main-block-title"
            style={topPanelStyle}>
          {client.top_panel_text.text}
        </h1>
        <div style={text_style}>
          { kyc_switch.renderMenu(this, {})}
        </div>
      </div>
    );
  }

  render = () => {

    const client = this.props.client;
    const {
      color,
    } = client;

    const container_style = {
      zIndex: "5",
      height: "35rem",
    };

    const login_style = {
      marginTop: "2rem",
      marginBottom: "0.1rem",
    };

    if (this.props.has_onboarding || this.props.logged_in) {
      console.log("redirect to", this.state.redirect_url);
      return (<Redirect push to={this.state.redirect_url} />);
    }
    const landing_page_url = css_file_to_url(this.props.config, client.landing_page_image);

    const wlf = this.props.app.wlf;
    const do_cde_primer = wlf.ui && wlf.ui.new_account_primer

    const primer = this.state.show_primer
      ? (<NewAccountPrimer component={this}/>)
      : null;

    const acct_cb = do_cde_primer
      ? this.showPrimer
      : this.createNewAccount2;

    const disp_type = this.props.location.pathname === "/new_account_mobile"
      ? DISPLAY_NEW_ACCOUNT_PASSWORD : DISPLAY_NEW_ACCOUNT

    return (
      <div>
        <div className="container-style-responsive" style={container_style}>
          <ImgTint img={landing_page_url} tint={color.top_panel_tint} />
          { <LoginBox
              style={login_style}
              display={disp_type}
              doingCreateAccount={this.state.loading}
              error={this.state.error_message}
              onNewAccount={acct_cb}/> }
          { this.renderRightPanel() }
          { primer }
        </div>
      </div>
    );
  }
}

export { NewAccount };
